import { XIcon } from "lucide-react";
import { Button } from "@capacit-com/lara-law-shared-ui";
import { TooltipContent } from "@capacit-com/lara-law-shared-ui";

export interface TooltipItem {
  id: string;
  label: string;
  metadata?: React.ReactNode;
  onRemove?: () => void;
}

interface ContextTooltipContentProps {
  items: TooltipItem[];
  emptyMessage?: string;
  canEdit?: boolean;
  side?: "top" | "bottom" | "left" | "right";
}

function ContextTooltipContent({
  items,
  emptyMessage = "Ingen elementer",
  canEdit = true,
  side = "bottom",
}: ContextTooltipContentProps) {
  if (items.length === 0) {
    return (
      <TooltipContent side={side} className="max-w-xs max-h-60 overflow-y-auto">
        <div className="text-sm text-muted-foreground">{emptyMessage}</div>
      </TooltipContent>
    );
  }

  return (
    <TooltipContent side={side} className="max-w-xs max-h-60 overflow-y-auto">
      <div className="space-y-1 w-50 overflow-y-auto">
        {items.map((item) => (
          <div
            key={item.id}
            className="flex items-center justify-between gap-2 text-sm group"
          >
            <div className="flex items-center gap-2 min-w-0 flex-1">
              <span className="line-clamp-2 wrap-break-word">{item.label}</span>
              {item.metadata && <div className="shrink-0">{item.metadata}</div>}
            </div>
            {canEdit && item.onRemove && (
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  item.onRemove?.();
                }}
                variant="ghost"
                size="sm"
                className="h-6 w-6 p-0 opacity-0 group-hover:opacity-100 transition-opacity shrink-0 hover:text-destructive"
                aria-label={`Remove ${item.label}`}
              >
                <XIcon className="h-3 w-3" />
              </Button>
            )}
          </div>
        ))}
      </div>
    </TooltipContent>
  );
}

export default ContextTooltipContent;
